import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { pick, isEqual } from 'lodash';

// Components
import ImageUploader from '../utils/ImageUploader';

// State
import { userTokenUpdate } from '../../store/actions/user';
import { addRoute } from '../../store/actions/route';
import { setpageTitle, getPromos } from '../../store/actions/siteInfo';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars';

// Utils
import { deleteTempImages } from '../../utils/uploadHelpers';

class AdminPromos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateErrors: {},
            updateLoading: false,
            updateSuccess: '',
            promiseCollection: [],
            promos: {},
        };

        this.props.addRoute(this.props.match);
        this.props.setpageTitle('Promos');

        this.handleImageAltUpdate = this.handleImageAltUpdate.bind(this);
        this.handleImageLinkUpdate = this.handleImageLinkUpdate.bind(this);
    }

    componentDidMount() {
        if (isEmpty(this.props.promos)) {
            this.props.getPromos();
        } else {
            this.setState({
                promos: this.props.promos,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.promos, this.props.promos)) {
            this.setState({
                promos: !!nextProps.promos ? nextProps.promos : {},
            });
        }
    }

    removeExistingImage(index) {
        let { promos } = this.state;
        delete promos[index];
        this.setState({
            promos: promos,
        });
    }

    handleSubmit() {
        // Set the state to let everything know that submitting is happening
        // We need to wait for this to actually complete and utilize the callback so any uploaders
        // actually know that they should begin uploading
        this.setState(
            {
                updateSuccess: '',
                updateErrors: {},
                updateLoading: true,
            },
            () => {
                // Wait until all uploader promises have completed
                Promise.all(this.state.promiseCollection)
                    .then((resolves) => {
                        // console.log('ok parent:', resolves)

                        this.setState({
                            promiseCollection: [],
                        });

                        this.completeSubmit(resolves);
                    })
                    .catch((err) => {
                        // console.log('err parent:', err)
                        this.setState({
                            updateLoading: false,
                            promiseCollection: [],
                        });
                    });
            }
        );
    }

    handleImageAltUpdate(altText, index, isCurrent, assetIndex) {
        let immutableState = this.state.promos;

        console.log(altText, assetIndex, isCurrent);

        // Alter the edited item as needed
        immutableState[assetIndex] = {
            ...immutableState[assetIndex],
            alt: altText,
        };

        // Set state with new object
        this.setState({
            promos: immutableState,
        });
    }

    handleImageLinkUpdate(hrefText, index, isCurrent, assetIndex) {
        let immutableState = this.state.promos;

        // Alter the edited item as needed
        immutableState[assetIndex] = {
            ...immutableState[assetIndex],
            href: hrefText,
        };

        // Set state with new object
        this.setState({
            promos: immutableState,
        });
    }

    getPromoData(promos, resolves, index) {
        const intialPromo = !!promos[index] ? promos[index] : { alt: '', href: '' };
        const res = !!resolves[index] ? resolves[index][0] : null;

        let item = pick(res.results, ['dirName', 'filename']);
        item.alt = !!intialPromo.alt ? intialPromo.alt : '';
        item.href = !!intialPromo.href ? intialPromo.href : '';
        item.index = index;

        return item;
    }

    completeSubmit(resolves) {
        const { user } = this.props;
        const { promos } = this.state;
        let uploadedUrls = [];

        // Default to existing records
        let promo_0 = promos[0];
        let promo_1 = promos[1];
        let promo_2 = promos[2];

        // If there are uploads, grab specific info from them for the new images
        if (!!resolves[0]) {
            promo_0 = this.getPromoData(promos, resolves, 0);
            if (!!resolves[0]) uploadedUrls.push(resolves[0][0].results);
        }

        if (!!resolves[1]) {
            promo_1 = this.getPromoData(promos, resolves, 1);
            if (!!resolves[1]) uploadedUrls.push(resolves[1][0].results);
        }

        if (!!resolves[2]) {
            promo_2 = this.getPromoData(promos, resolves, 2);
            if (!!resolves[2]) uploadedUrls.push(resolves[2][0].results);
        }

        // Put data together
        const data = {
            promo_0,
            promo_1,
            promo_2,
        };

        //promos/chunked
        const token = user.token;
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token };
        return axios
            .post(REACT_APP_API_URL + 'promos/chunked', data, { headers: AUTH_HEADER })
            .then((response) => {
                if (!!response.data.token) {
                    this.props.userTokenUpdate('admin', response.data.token);
                }

                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: !isEmpty(response.data.errors)
                            ? response.data.errors
                            : { general: response.data.message },
                    });

                    deleteTempImages(uploadedUrls, this.props.user.token).catch((err) => {
                        console.log(err);
                    });
                } else {
                    // Reset state
                    this.setState({
                        updateLoading: false,
                        updateSuccess: response.data.message,
                    });

                    this.props.userTokenUpdate('admin', response.data.token);

                    // Get promos
                    this.props.getPromos();
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: {
                            general: err.response.data.error
                                ? err.response.data.error
                                : err.response.data.message,
                        },
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateErrors: { general: err.message },
                    });
                }

                deleteTempImages(uploadedUrls, this.props.user.token).catch((err) => {
                    console.log(err);
                });
            });
    }

    render() {
        const {
            updateErrors,
            updateLoading,
            updateSuccess,
            promiseCollection,
            promos,
        } = this.state;

        return (
            <div>
                <h1>Promos</h1>

                {updateSuccess && (
                    <div className="success msg_animate">{updateSuccess}</div>
                )}

                <div className="new-banner">
                    <ImageUploader
                        loading={updateLoading}
                        clear={!!updateSuccess}
                        required={false}
                        textLarge={'Promo 1'}
                        type={'0'}
                        uploadAssetType={'promo'}
                        addPromise={(promise) => promiseCollection.push(promise)}
                        handleExistingImageRemoval={(index) =>
                            this.removeExistingImage(0, index)
                        }
                        initialImages={!!promos[0] ? [promos[0]] : []}
                        imageProperty={'img'}
                        assetIndex={0}
                        error={updateErrors.promo_0}
                        toolbarTypes={{
                            alt: {
                                update: this.handleImageAltUpdate,
                            },
                            link: {
                                update: this.handleImageLinkUpdate,
                            },
                        }}
                    />
                    <ImageUploader
                        loading={updateLoading}
                        clear={!!updateSuccess}
                        required={false}
                        textLarge={'Promo 2'}
                        type={'1'}
                        uploadAssetType={'promo'}
                        addPromise={(promise) => promiseCollection.push(promise)}
                        handleExistingImageRemoval={(index) =>
                            this.removeExistingImage(1, index)
                        }
                        initialImages={!!promos[1] ? [promos[1]] : []}
                        imageProperty={'img'}
                        assetIndex={1}
                        error={updateErrors.promo_1}
                        toolbarTypes={{
                            alt: {
                                update: this.handleImageAltUpdate,
                            },
                            link: {
                                update: this.handleImageLinkUpdate,
                            },
                        }}
                    />
                    <ImageUploader
                        loading={updateLoading}
                        clear={!!updateSuccess}
                        required={false}
                        textLarge={'Promo 3'}
                        type={'2'}
                        uploadAssetType={'promo'}
                        addPromise={(promise) => promiseCollection.push(promise)}
                        handleExistingImageRemoval={(index) =>
                            this.removeExistingImage(2, index)
                        }
                        initialImages={!!promos[2] ? [promos[2]] : []}
                        imageProperty={'img'}
                        assetIndex={2}
                        error={updateErrors.promo_2}
                        toolbarTypes={{
                            alt: {
                                update: this.handleImageAltUpdate,
                            },
                            link: {
                                update: this.handleImageLinkUpdate,
                            },
                        }}
                    />
                </div>

                <div className="btn_container">
                    {updateErrors.general && (
                        <div
                            className="error msg_animate"
                            dangerouslySetInnerHTML={{ __html: updateErrors.general }}
                        />
                    )}
                    <button
                        className={'btn submit-btn' + (updateLoading ? ' loading' : '')}
                        onClick={() => this.handleSubmit()}
                        disabled={updateLoading}
                    >
                        <span>Submit Changes</span>
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        promos: state.siteInfo.promos,
    };
};

export default connect(
    mapStateToProps,
    { userTokenUpdate, addRoute, setpageTitle, getPromos }
)(AdminPromos);



// WEBPACK FOOTER //
// ./src/components/admin/AdminPromos.js